<form class="wrapper" #formRef="ngForm">
	<ng-container *ngIf="entity">
		<h2 *ngIf="entity?.id">{{ 'EDIT_' + label | translate }} </h2>
		<h2 *ngIf="!entity?.id">{{ 'CREATE_' + label | translate }} </h2>
		<div class="status">
			<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate"></bb-status>
		</div>
		<div class="lang-cols">
			<div class="lang-col">
				<bb-form-element *ngIf="entity?.originalfilename" [label]="'ORIGINAL_FILENAME' | translate">
					<span>{{ entity.originalfilename }}</span>
				</bb-form-element>

				<bb-form-element *ngIf="!entity?.automatedName" [form]="form" [label]="'LANGUAGE' | translate">
					<bb-entity-selector
						required
						[(ngModel)]="entity.isocode"
						(ngModelChange)="onIsocodeChange(entity.isocode)"
						[options]="languageOptions"
						[name]="label + '-language'"
					></bb-entity-selector>
				</bb-form-element>

				<bb-form-element *ngIf="entity?.automatedName" [label]="'LANGUAGE' | translate">
					<span>{{ entity.automatedName }}</span>
				</bb-form-element>

				<div class="actions" *ngIf="entity && form">
					<button class="button" (click)="delete()" [hidden]="isNew"><i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</button>
					<button class="button submit" (click)="saveQuickEdit()"><i class="fa fa-floppy-o"></i> {{ 'SAVE' || translate }}</button>
					<button class="button cancel" (click)="onCancelClick()"><i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}</button>
				</div>
			</div>
		</div>
	</ng-container>
</form>
